export enum MexusEntity {
  PROD_ORDER = 'PROD_ORDER',

  WORK_ITEM = 'WORK_ITEM',

  WORK_BATCH = 'WORK_BATCH',

  PACKAGE = 'PACKAGE',

  WORK_CENTER = 'WORK_CENTER',
}
